<template>
  <div>
    <NewRuhContainer />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import NewRuhContainer from "@/components/aberration/new/ruh/NewRuhContainer.vue";

export default Vue.extend({
  components: {
    NewRuhContainer,
  },
});
</script>
